import { render, staticRenderFns } from "./UpdateOriginalEmailModal.vue?vue&type=template&id=24cb74e6&"
import script from "./UpdateOriginalEmailModal.vue?vue&type=script&lang=js&"
export * from "./UpdateOriginalEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports